<script>
export default {
    name: 'AppButton',
    props: {
        variant: { type: String, default: 'primary' }, // primary | secondary | ghost | danger | success
        size:    { type: String, default: 'md' },      // xs | sm | md
        type:    { type: String, default: 'button' },
        loading: { type: Boolean, default: false },
        disabled:{ type: Boolean, default: false },
        as:      { type: String, default: 'button' },  // button | a
        href:    { type: String, default: null },
    },
    emits: ['click'],
    computed: {
        classes() {
            const base = 'inline-flex items-center justify-center gap-2 rounded-md font-medium whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 disabled:opacity-50 disabled:pointer-events-none';
            // `xs` exists for inline pagers (Aktivität / Notizen / ToDos
            // on CustomerDetail). Don't promote it for primary actions —
            // `sm` is already the smallest comfortable click target.
            const sizes = {
                xs: 'h-6 px-2 text-xs',
                sm: 'h-8 px-3 text-sm',
                md: 'h-9 px-4 text-base',
            };
            const variants = {
                primary:   'bg-accent text-white hover:bg-accent-hover',
                secondary: 'bg-surface text-ink border border-line hover:bg-hover',
                ghost:     'bg-transparent text-ink hover:bg-hover',
                danger:    'bg-danger text-white hover:bg-danger/90',
                success:   'bg-success text-white hover:bg-success/90',
            };
            return [base, sizes[this.size] || sizes.md, variants[this.variant] || variants.primary];
        },
    },
};
</script>

<template>
    <component :is="as" :type="as === 'button' ? type : null" :href="href"
               :class="classes" :disabled="disabled || loading"
               @click="$emit('click', $event)">
        <svg v-if="loading" class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"/>
            <path class="opacity-75" d="M4 12a8 8 0 0 1 8-8" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
        </svg>
        <slot />
    </component>
</template>
